import { AdminNotification, GetAllAdminNotifications } from "../../Models/AdminNotification";
import { PagedResult } from "../../Models/PagedResult";
import api from "../axios";

export const adminNotificationService = {
  getAll: async (data: GetAllAdminNotifications): Promise<PagedResult<AdminNotification>> => {
    const queryParams = new URLSearchParams();

    queryParams.append("page", data.page.toString());
    queryParams.append("pageSize", data.pageSize.toString());

    if (data.category !== undefined && data.category !== null) {
      queryParams.append("category", data.category.toString());
    }

    const response = await api.get(`/admin-notification?${queryParams.toString()}`);
    return response.data;
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await api.get('/admin-notification/unread-count');
    return response.data;
  },

  markAsRead: async (id: string): Promise<void> => {
    await api.put(`/admin-notification/${id}/read`);
  },

  markAllAsRead: async (): Promise<void> => {
    await api.put('/admin-notification/read-all');
  }
};
